function initStoreLocator(props) {
	const states = {
		"retail": [...new Set(props.location.filter((l) => l.list_location_for === "retail" || l.list_location_for === "both").map((l) => l.state))],
		"business_center": [...new Set(props.location.filter((l) => l.list_location_for === "business_center" || l.list_location_for === "both").map((l) => l.state))],
	}
	const showrooms = props.location;
	let selectedApptType = null;
	let currentlySelectedStoreName = null;
	const appointmentOptionList = [{ label: "COME TO US", type: "retail" }, { label: "COME TO YOU", type: "business_center" }];
	const skipAppointmentTypeStep = props.skip_appt_type;

	// Permanently-closed showrooms. This mirrors the closure list in sections/locations.liquid,
	// but that section keys off the metaobject `system.id` while the showroom data available here
	// only exposes city/state/address, so we match on city + state code instead. Keep the two in sync.
	// (Previously entries carried a closureDateIso that gated when the store flipped to closed;
	// every one of those dates has now passed, so the dates were dropped and all entries are
	// treated as always closed. If a future-dated closure is needed again, add closureDateIso
	// back the same way isPermanentlyClosedStore() below already supports it.)
	// `address` is required whenever city+state alone could match more than one store (e.g. two
	// Miami, FL showrooms share that city/state/zip) — it's matched as a case-insensitive
	// substring against the store's street address so it survives minor formatting differences.
	const permanentlyClosedStores = [
		{ city: "San Diego", stateCode: "CA" },
		{ city: "Charlotte", stateCode: "NC" },
		{ city: "White Plains", stateCode: "NY" },
		{ city: "Garden City", stateCode: "NY" },
		{ city: "Nashville", stateCode: "TN" },
		{ city: "Las Vegas", stateCode: "NV" },
		{ city: "Beverly Hills", stateCode: "CA" },
		{ city: "Aventura", stateCode: "FL" },
		{ city: "Durham", stateCode: "NC" },
		{ city: "Coral Gables", stateCode: "FL" },
		{ city: "Miami", stateCode: "FL", address: "2058 NW Miami Ct" },
		{ city: "Jacksonville", stateCode: "FL" },
	];

	function isPermanentlyClosedStore(store) {
		if (!store || !store.city || !store.state) return false;
		const city = String(store.city).trim().toLowerCase();
		// `state` comes through as e.g. "CA-California" — the part before the dash is the code
		const stateCode = String(store.state).split("-")[0].trim().toUpperCase();
		const address = String(store.address || "").trim().toLowerCase();
		const match = permanentlyClosedStores.find(
			(s) =>
				s.city.toLowerCase() === city &&
				s.stateCode === stateCode &&
				(!s.address || address.includes(s.address.toLowerCase()))
		);
		if (!match) return false;
		if (!match.closureDateIso) return true;
		// Compare at UTC midnight of the closure date so the flip happens on the calendar date
		// regardless of the visitor's local time zone
		return new Date() >= new Date(match.closureDateIso + "T00:00:00Z");
	}

	$(document).ready(() => {
		const storeLocatorSteps = $(".store-locator__step");
		const stateFilterWrap = $(".store-locator__state-filter__list");
		const appointmentTypeSelectWrap = $(".store-locator__appt-type__list");
		const loationsListWrap = $(".store-locator__locations-list");
		const selectedStoreWrap = $(".selected-store");
		const storeLocatorContainer = $(".store-locator__container");
		const calRenderArea = $(".cal-render-area");
		const sliderLocationWrap = $(".location_slider_sec__slider");
		let multipleLocations = false;

		(() => {
			let zipCode = new URLSearchParams(window.location.search).get('zip');
			$(storeLocatorSteps[0]).addClass("active");
			$(".in-person").click(() => goToNextStep());
			$(".step-go-back").click(() => goToPrevStep());
			$(".step-reset").click(() => resetStep());
			$(".phone-call").click(() => renderCal(props.phone_cal_link, "multistep"));
			renderAppointmentTypes();
			renderSliderGrid();
			if (zipCode !== "00000") {
				fastForwardSteps();
			}
			else {
				renderCal(props.phone_cal_link, "multistep")
			}
			checkIfRetailParamsExists();
		})();

		function fastForwardSteps() {
			let zipCode = new URLSearchParams(window.location.search).get('zip');
			selectedApptType = new URLSearchParams(window.location.search).get('appt_type');
			let selectedState = new URLSearchParams(window.location.search).get('state');

			const stateCodes = Array.from(
				new Set(showrooms.map(store => store.state.split('-')[0]))
			);
			if(selectedState && stateCodes.includes(selectedState.toUpperCase())) {
				selectedApptType = "retail";
				const filteredLocations = props.location.filter((l) => {
					const stateCode = l.state.split('-')[0];
					const isSelectedState = stateCode.toUpperCase() == selectedState.toUpperCase();
					const isSelectedApptType = l.list_location_for === selectedApptType || l.list_location_for === "both";
					return isSelectedState && isSelectedApptType;
				});
				renderStateFilter();
				renderFilteredLocation(filteredLocations);
				storeLocatorSteps.removeClass("active");
				$('[data-step-index="4"]').addClass("active");		
			} else if (zipCode != null && selectedApptType != null) {
				if (zipCode === "00000") {
					renderCal(props.phone_cal_link, "multistep");
				} else {
					const filteredLocation = showrooms.filter(s => s.zip_code === zipCode && (s.list_location_for === selectedApptType || s.list_location_for === "both"));
					if (filteredLocation.length) {
						renderStateFilter();
						renderFilteredLocation(props.location.filter((l) => l.state === filteredLocation[0].state && (l.list_location_for === selectedApptType || l.list_location_for === "both")));
						storeLocatorSteps.removeClass("active");
						$("#finalStepCal").addClass("active");
						handeLocationSelect(filteredLocation[0], true);
					}
				}
			} else {
				if (zipCode != null) {
					selectedApptType = "retail";
					if (zipCode === "00000") {
						renderCal(props.phone_cal_link, "multistep")
					} else {
						const filteredLocation = showrooms.filter(s => s.zip_code === zipCode && (s.list_location_for === selectedApptType || s.list_location_for === "both"));
						if (filteredLocation.length < 2) {
							renderStateFilter();
							renderFilteredLocation(props.location.filter((l) => l.state === filteredLocation[0].state && (l.list_location_for === selectedApptType || l.list_location_for === "both")));
							goToNextStep();
							handeLocationSelect(filteredLocation[0], false);
						}
						else {			
							multipleLocations = true;
							const urlParams = new URLSearchParams(window.location.search);
							const urlZip = urlParams.get('zip');
							const urlStoreId = urlParams.get('store_id');
							renderStateFilter();
							renderFilteredLocation(filteredLocation);
							goToNextStep();
							if (urlZip && urlStoreId) {
								const matchedLocation = filteredLocation.find(
									loc => loc.zip_code === urlZip && String(loc.store_id) === String(urlStoreId)
								);
								if (matchedLocation) {
									handeLocationSelect(matchedLocation, false);
								}
							}
						}
					}

				}
				if (selectedApptType != null) {
					goToNextStep();
				}

			}
		}

		function goToNextStep() {
			const activeStep = storeLocatorSteps.filter(".active");
			let nextStepIndex = $(activeStep).attr("data-next-step");
			if(skipAppointmentTypeStep || new URLSearchParams(window.location.search).get('appt_type')){
				selectedApptType = "retail";
				if(activeStep.attr("data-step-index") == 1){
					renderStateFilter();
					$(activeStep).removeClass("active");
					$(`.store-locator__step[data-step-index='3']`).addClass("active");
				}
				else{
					$(activeStep).removeClass("active");
					$(`.store-locator__step[data-step-index='${nextStepIndex}']`).addClass("active");
					if(multipleLocations){
						$(`.store-locator__step[data-step-index='${nextStepIndex}']`).attr("data-multiple-location", "true");
					}
				}
			}
			else {
				$(activeStep).removeClass("active");
				$(`.store-locator__step[data-step-index='${nextStepIndex}']`).addClass("active");
				if(multipleLocations){
					$(`.store-locator__step[data-step-index='${nextStepIndex}']`).attr("data-multiple-location", "true");
				}
			}
		}

		function resetStep() {
			calRenderArea[0].innerHTML = "";
			$(storeLocatorContainer).removeClass("col--active");
		}

		function goToPrevStep() {
			const activeStep = storeLocatorSteps.filter(".active");
			const prevStep = storeLocatorSteps.index(activeStep) - 1;
			if (prevStep >= 0) {
				$(activeStep).removeClass("active");
				if(skipAppointmentTypeStep || new URLSearchParams(window.location.search).get('appt_type')){
					if((activeStep.attr("data-step-index") == 3)){
						$(`.store-locator__step[data-step-index='1']`).addClass("active");
					}
					else{
						if(multipleLocations){
							resetMultipleLocations();
						} else {
							$(`.store-locator__step[data-step-index='${prevStep + 1}']`).addClass("active");
						}
					}
				}
				else{
					if(multipleLocations){
						resetMultipleLocations();
					} else {
						$(`.store-locator__step[data-step-index='${prevStep + 1}']`).addClass("active");
					}
				}
				resetStep();
				
			}
		}

		function resetMultipleLocations() {
			multipleLocations = false;
			let zipCode = new URLSearchParams(window.location.search).get('zip');
			const matchedShowroom = showrooms.find(s => s.zip_code === zipCode);
			let filteredStateLocation = [];
			if (matchedShowroom) {
				filteredStateLocation = showrooms.filter(
					s => s.state === matchedShowroom.state &&
						(s.list_location_for === selectedApptType || s.list_location_for === "both")
				);
				renderStateFilter();
				renderFilteredLocation(filteredStateLocation);
				$(`.store-locator__step[data-step-index='4']`).addClass("active");
			}
		}

		function renderCal(cal_link = "", ui_type) {
			// if (cal_link === "" || cal_link === undefined || cal_link === null) throw new Error(`Invalid or Empty Cal link provided to renderer`)
			calRenderArea[0].innerHTML = "";
			if (cal_link === "" || cal_link === undefined || cal_link === null) {
				// Hide calendar area when link is empty
				$(calRenderArea).hide();
				console.warn("Calendar link is empty, hiding calendar area");
				return;
			}
			// Show calendar area if it was hidden
			$(calRenderArea).show();
			if (ui_type == "multistep") {
				$(storeLocatorContainer).addClass("col--active");
			}
			if (cal_link.includes("calendly")) {
				Calendly.initInlineWidget({
					url: cal_link,
					parentElement: $(".cal-render-area")[0],
				});
			}
			if (cal_link.includes("cal.aroma360.com")) {
				let urlObject = new URL(cal_link);
				const calPath = urlObject.pathname.substring(1);
				let prefiledDatas = prefillCal() || {};
				Cal("init", { origin: "https://cal.aroma360.com" });
				if (prefiledDatas && Object.keys(prefiledDatas).length !== 0) {
					Cal("inline", {
						elementOrSelector: `.cal-render-area`,
						config: prefiledDatas,
						calLink: calPath,
						layout: "month_view",
					});
				}
				else {
					Cal("inline", {
						elementOrSelector: `.cal-render-area`,
						calLink: calPath,
						layout: "month_view",
					});
				}

				Cal("ui", {
					styles: { branding: { brandColor: "#000000" } },
					hideEventTypeDetails: false,
					layout: "month_view",
				});
				if (ui_type == "slider") {
					$("html, body").animate(
						{
							scrollTop: $(".location_slider_cals_wrapper").offset().top,
						},
						1000
					);
				}
				if (ui_type === "multistep") {
					calRenderArea[0].scrollIntoView({ behavior: 'smooth' });
				}
			}
		}


		function renderStateFilter() {
			if (stateFilterWrap.length) {
				stateFilterWrap[0].innerHTML = "";
				states[selectedApptType].forEach((s) => {
					const stateItem = document.createElement("button");
					stateItem.classList.add("state-filter__option");
					stateItem.innerHTML = `${s.split("-")[1]}`;
					stateItem.addEventListener("click", () => {
						goToNextStep();
						renderFilteredLocation(props.location.filter((l) => l.state === s && (l.list_location_for === selectedApptType || l.list_location_for === "both")));
					});
					stateFilterWrap[0].appendChild(stateItem);
				});
			}
		}

		function renderAppointmentTypes() {
			if (appointmentTypeSelectWrap.length) {
				appointmentTypeSelectWrap[0].innerHTML = "";
				appointmentOptionList.forEach(a => {
					const appointmentOption = document.createElement("button");
					appointmentOption.classList.add("app-type__option");
					appointmentOption.setAttribute("data-appt-type", a.type)
					appointmentOption.innerHTML = a.label;
					appointmentOption.addEventListener("click", (e) => {
						selectedApptType = a.type;
						renderStateFilter();
						goToNextStep();
					});
					appointmentTypeSelectWrap[0].appendChild(appointmentOption);
				});
			}
		}

		function renderFilteredLocation(locations) {
			const currentDate = new Date(getCurrentDateFormatted());
			loationsListWrap[0].innerHTML = "";
			locations.forEach((l) => {
				const locationItem = document.createElement("button");
				locationItem.classList.add("locations-list__option");
				const storeOpeningDate = new Date(l.opening_date + "T00:00:00Z");
				const formattedDate = storeOpeningDate.toLocaleDateString("en-US", {
					month: "short",
					day: "numeric",
					year: "numeric",
					timeZone: 'UTC'
				});
				// Permanently-closed store: greyed, non-interactive tile with no click handler and
				// no calendar link (mirrors the closed state in sections/locations.liquid)
				if(isPermanentlyClosedStore(l)){
					locationItem.disabled = true;
					locationItem.classList.add('disabled', 'permanently-closed');
					// Keep the normal centered tile layout for the copy; the closed notice is
					// absolutely positioned (see .location-closed-note) so it stays out of flow
					// and doesn't push the name/address against the tile edge.
					locationItem.innerHTML = `
					<span class="location-city">
						${l.name}
					</span>
					<span class="location-address">
						${l.address}, ${l.city}, ${l.state.split("-")[0]} ${l.zip_code}
					</span>
					<span class="location-closed-note">Permanently Closed</span>
					`;
					loationsListWrap[0].appendChild(locationItem);
					return;
				}
				if(l?.opening_date && (storeOpeningDate > currentDate)){
					locationItem.disabled = true;
					locationItem.classList.add('disabled');
					locationItem.innerHTML = `
					<span class="location-container">
						<span class="location-city">
							${l.name}
						</span>
						<span class="location-address">
							${l.address}, ${l.city}, ${l.state.split("-")[0]} ${l.zip_code}
						</span>
					</span>
					 <span class="location-opening-date">
					 	<span class="opening-title">Coming Soon</span>
                       ${formattedDate}
                    </span>
                `;
				}
				else{
					locationItem.innerHTML = `
                    <span class="location-city">
                        ${l.name}
                    </span>
                    <span class="location-address">
                        ${l.address}, ${l.city}, ${l.state.split("-")[0]} ${l.zip_code}
                    </span>
                `;
				}


				locationItem.addEventListener("click", () => handeLocationSelect(l));
				loationsListWrap[0].appendChild(locationItem);
			});
		}

		function handeLocationSelect(selectedLocation, fastForward = false) {
			// Safety net: closed stores render no click handler, but a ?zip= / ?store_id= deep link
			// can still route here via fastForwardSteps. Never open a booking calendar for one.
			if (isPermanentlyClosedStore(selectedLocation)) {
				return;
			}
			selectedStoreWrap[0].innerHTML = "";
			const selectedItem = document.createElement("div");
			selectedItem.classList.add("selected-store__card");
			selectedItem.innerHTML = `
				<span class="location-city">
					${selectedLocation.name}
				</span>
				<span class="location-address">
				${selectedLocation.address}, ${selectedLocation.city}, ${selectedLocation.state.split("-")[0]} ${selectedLocation.zip_code
				}
				</span>
			`;
			selectedStoreWrap[0].appendChild(selectedItem);
			if (!fastForward) goToNextStep();
			let calLink = null;
			currentlySelectedStoreName = selectedLocation.name;
			if (selectedApptType === "retail") {
				calLink = selectedLocation.calender_link;
			}

			if (selectedApptType === "business_center") {
				calLink = selectedLocation.home_appointment_cal_link;
			}
			//console.log(selectedApptType, "selected appt type");
			renderCal(calLink, "multistep");
		}



		function renderSliderGrid() {
			if (sliderLocationWrap.length) {
				const currentDate = new Date(getCurrentDateFormatted());
				sliderLocationWrap[0].innerHTML = "";
				showrooms.forEach((showroom, index) => {

					let person;
					let phone;
					let storeOpeningDate;

					if (window.location.pathname.includes('/es/')) {
						person = 'Consulta en persona'
						phone = 'Consulta por telefono'
					} else {
						person = 'In person consultation'
						phone = 'Phone call consultation'
					}

					const showroomItem = document.createElement("div");
					if(showroom.opening_date){
						storeOpeningDate = new Date(showroom.opening_date + "T00:00:00Z");
					}

					showroomItem.classList.add("location_slider__showroom");

					// Permanently-closed store: overlay + disabled CTA, no appointment buttons wired up
					// (mirrors the closed state in sections/locations.liquid)
					if(isPermanentlyClosedStore(showroom)){
						showroomItem.innerHTML = `
						<div class="location_slider__showroom_img">
						<img src=${showroom.store_image} alt="${showroom.name}">
						<div class="location_slider__overlay">
							<span class="overlay-text">Permanently Closed</span>
						</div>
						<div class="location_slider__ctas">
							<button class="location_slider__cta-btn disabled">
								Permanently Closed
							</button>
						</div>
						</div>
						<div class="location_slider__showroom_address">
							<div class="location_slider__showroom_add-title">
							<p class="heading h5">${showroom.name}</p>
							</div>
							<div class="location_slider__showroom_add-desc">
							<p>
								${showroom.address}, ${showroom.state.split("-")[0]} ${showroom.zip_code}
							</p>
							</div>
						</div>
						`;
						sliderLocationWrap[0].appendChild(showroomItem);
						if (showrooms.length == index + 1) {
							loadSlickCarousel();
						}
						return;
					}

					if(showroom?.opening_date && (storeOpeningDate > currentDate)){

						const formattedDate = storeOpeningDate.toLocaleDateString("en-US", {
							month: "short",
							day: "numeric",
							year: "numeric" ,
							timeZone: 'UTC'
						});

						showroomItem.innerHTML = `
						<div class="location_slider__showroom_img">
						<img src=${showroom.store_image} alt="${showroom.name}">
						<div class="location_slider__overlay">
							<span class="overlay-text">Coming Soon</span>
						</div>
						<div class="location_slider__ctas">
							<button class="location_slider__cta-btn disabled">
								Opening: ${formattedDate}
							</button>
						</div>
						</div>
						<div class="location_slider__showroom_address">
							<div class="location_slider__showroom_add-title">
							<p class="heading h5">${showroom.name}</p>
							</div>
							<div class="location_slider__showroom_add-desc">
							<p>
								${showroom.address}, ${showroom.state.split("-")[0]} ${showroom.zip_code}
							</p>
							</div>
						</div>
						`;
					} else{
						showroomItem.innerHTML = `
					<div class="location_slider__showroom_img">
					<img src=${showroom.store_image} alt="${showroom.name}">
					<div class="location_slider__ctas">
						<button class="location_slider__cta-btn in-person-appt ${!showroom.show_in_person_calender ? "hide" : ""}">
							${person}
						</button>
						<button class="location_slider__cta-btn phone-call-appt ${!showroom.show_phone_calender ? "hide" : ""}">
							${phone}
						</button>
					</div>
					</div>
					<div class="location_slider__showroom_address">
						<div class="location_slider__showroom_add-title">
						<p class="heading h5">${showroom.name}</p>
						</div>
						<div class="location_slider__showroom_add-desc">
						<p>
							${showroom.address}, ${showroom.state.split("-")[0]} ${showroom.zip_code}
						</p>
						</div>
					</div>
					`;
					}

					var inPersonButton = showroomItem.querySelector(".in-person-appt");
					if(inPersonButton){
						inPersonButton.addEventListener("click", () => renderCal(showroom.calender_link, "slider"));
					}

					sliderLocationWrap[0].appendChild(showroomItem);
					if (showrooms.length == index + 1) {
						loadSlickCarousel();
					}
				});
			}
		}

		function loadSlickCarousel() {
			$(".location_slider_sec__slider").slick({
				lazyLoad: "ondemand",
				infinite: true,
				slidesToShow: 5,
				slidesToScroll: 5,
				dots: false,
				prevArrow:
					'<button class="slide-arrow slick-prev"><svg fill="#000000" version="1.1" baseProfile="tiny" id="Layer_1" xmlns:x="&ns_extend;" xmlns:i="&ns_ai;" xmlns:graph="&ns_graphs;"xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:a="http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/"     width="800px" height="800px" viewBox="0 0 42 42" xml:space="preserve"> <polygon fill-rule="evenodd" points="31,38.32 13.391,21 31,3.68 28.279,1 8,21.01 28.279,41 "/></svg></button>',
				nextArrow:
					'<button class="slide-arrow slick-next"><svg fill="#000000" version="1.1" baseProfile="tiny" id="Layer_1" xmlns:x="&ns_extend;" xmlns:i="&ns_ai;" xmlns:graph="&ns_graphs;" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:a="http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/"    width="800px" height="800px" viewBox="0 0 42 42" xml:space="preserve"> <polygon fill-rule="evenodd" points="11,38.32 28.609,21 11,3.68 13.72,1 34,21.01 13.72,41 "/></svg></button>',
				responsive: [
					{
						breakpoint: 1360,
						settings: {
							slidesToShow: 4,
                            slidesToScroll: 4
						},
					},
					{
						breakpoint: 1000,
						settings: {
							slidesToShow: 3,
                            slidesToScroll: 3
						},
					},
					{
						breakpoint: 800,
						settings: {
							slidesToShow: 2,
                            slidesToScroll: 2,
						},
					},
					{
						breakpoint: 600,
						settings: {
							slidesToShow: 1,
                            slidesToScroll: 1,
						},
					},
				],
			});
			$(".phone-call-appt").click(() => renderCal(props.phone_cal_link, "slider"));
		}

		function prefillCal() {
			//console.log("prefill running....");
			try {
				let lead_form_submissions = JSON.parse(localStorage.getItem('lead_form_submissions'));
				let calConfig = {
					lob: "Aroma360",
					store_location: currentlySelectedStoreName,
					referrer_url: document.referrer,
					last_url: window.location.href
				};

				if (selectedApptType === "retail") {
					calConfig.lead_type = "retail";
				}

				if (selectedApptType === "business_center") {
					calConfig.lead_type = "business center";
				}

				if (lead_form_submissions && lead_form_submissions.length) {
					let lastSubmittedLeadkey = utilFetchCookieValue("last_lead_key");
					let lastLeadFormEntry = lead_form_submissions.find((l) => l.hasOwnProperty(lastSubmittedLeadkey));
					if (!lastLeadFormEntry) {
						let lastSubmission = lead_form_submissions[lead_form_submissions.length - 1]
						lastSubmittedLeadkey = Object.keys(lastSubmission)[0];
						lastLeadFormEntry = lastSubmission[lastSubmittedLeadkey];
					}else {
						lastLeadFormEntry = lastLeadFormEntry[lastSubmittedLeadkey] || null;
					}
					//console.log(lastLeadFormEntry,"lead form entry");
					if (lastLeadFormEntry) {
						calConfig.lead_key = lastSubmittedLeadkey;
						calConfig.name = lastLeadFormEntry.first_name + "  " + lastLeadFormEntry.last_name;
						calConfig.email = lastLeadFormEntry.email;
						calConfig.phone = formatPhoneNumber(lastLeadFormEntry.phone_mobile);
						calConfig.utm_campaign = lastLeadFormEntry.utm_campaign || "";
						calConfig.utm_content = lastLeadFormEntry.utm_content || "";
						calConfig.utm_medium = lastLeadFormEntry.utm_medium || "";
						calConfig.utm_source = lastLeadFormEntry.utm_source || "";
						calConfig.utm_term = lastLeadFormEntry.utm_term || "";
						calConfig.affiliate_id = lastLeadFormEntry.affiliate_id || "";
						calConfig.location = JSON.stringify({
							value: "phone",
							optionValue: formatPhoneNumber(lastLeadFormEntry.phone_mobile)
						});
						calConfig.landing_url = lastLeadFormEntry.landing_url || "";
						calConfig.click_id = lastLeadFormEntry.click_id || "";
						calConfig.ad_platform = lastLeadFormEntry.platform || "";
					}

				} else {
					calConfig.utm_campaign = utilFetchCookieValue('utm_campaign');
					calConfig.utm_content = utilFetchCookieValue('utm_content');
					calConfig.utm_medium = utilFetchCookieValue('utm_medium');
					calConfig.utm_source = utilFetchCookieValue('utm_source');
					calConfig.utm_term = utilFetchCookieValue('utm_term');
					calConfig.landing_url = utilFetchCookieValue('landing_url');
					// ad platform and click id
					let latestClickID = utilGetLatestClickID();
					if (latestClickID) {
						calConfig.click_id = latestClickID.clickID.value;
						calConfig.ad_platform = latestClickID.platform;
					}
				}

				for (var key in calConfig) {
					if (calConfig.hasOwnProperty(key) && (calConfig[key] === "" || calConfig[key] === null)) {
						delete calConfig[key];
					}
				}
				return calConfig;
			} catch (error) {
				console.log(error);
			}
		}

		function formatPhoneNumber(phoneNumber) {
			const digits = phoneNumber.replace(/\D/g, "");

			if (digits.length === 11 && digits.startsWith("1")) {
				return "+" + digits;
			}
			

			if (digits.length === 10) {
				return "+1" + digits;
			}
			
			return phoneNumber;
		}

		function checkIfRetailParamsExists() {
			// Get the URL parameters
			const urlParams = new URLSearchParams(window.location.search);

			// Check if the amtoff parameter exists
			if (urlParams.has('amtoff')) {
				const amtoffValue = atob(urlParams.get('amtoff')) + ' ';
				$('.store-locator__text strong').text(amtoffValue);
			}

			// Check if the pterms parameter exists

			if (urlParams.has('pterms')) {
				const ptermsValue = '*' + urlParams.get('pterms').replace(/\\n/g, '<br>')  // Convert \n to <br>
					.replace(/(http:\/\/www\.Aroma360\.com|www\.Aroma360\.com|https:\/\/www\.Aroma360\.com)/g, '<a href="https://www.Aroma360.com" target="_blank">www.Aroma360.com</a>');  // Convert URL to hyperlink;;
				$('.store-locator__footer-condition p').html(ptermsValue);
			}
		}

		function getCurrentDateFormatted(format) {
			const date = new Date();
			const year = date.getFullYear();
			const month = String(date.getMonth() + 1).padStart(2, '0');
			const day = String(date.getDate()).padStart(2, '0');
			return `${year}-${month}-${day}`;
		};

		function convertToUSDateFormat(isoDateString){
			const [year, month, day] = isoDateString.split('-');
			const usDateFormat = `${month}-${day}-${year}`;
			return usDateFormat;
		};
	});
}

